// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2cusn","sendOtp":"AuthorizeToLogin_sendOtp__3l7eI"};